import type { ContainerModule } from '@yandex-int/k-common';
import React from 'react';

import { CourseContainerModuleLink } from '../__module-link/course-container__module-link';
import './course-container__module-link-list.scss';

interface Props {
    modules: Array<ContainerModule>;
    titlesOnly?: boolean;
}

export const CourseContainerModuleLinkList = ({ modules, titlesOnly }: Props) => {
    return (
        <div className="course-container__module-link-list">
            {modules.map((containerModule) => (
                <CourseContainerModuleLink
                    containerModule={containerModule}
                    key={containerModule.module.id}
                    titlesOnly={titlesOnly}
                />
            ))}
        </div>
    );
};
